import { Component, Input } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { CallService } from 'src/app/services/call.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-medical-records',
  templateUrl: './medical-records.component.html',
  styleUrls: ['./medical-records.component.css'],
  standalone: false
})
export class MedicalRecordsComponent {
  @Input()
  patientCalls!: {data: Call[], total: number};

  @Input()
  call!: Call;

  skip = 0;
  limit = 10;
  index = 0;

  errorMessage?: string | null;

  constructor(
    private callService: CallService,
    private toastService: ToastService,
  ) { }


  getPatientCalls(): void {
    this.errorMessage = null;
    this.callService.getPatientCalls(this.call.id, this.skip, this.limit)
    .then((response: Call[]) => {
      this.patientCalls.data = [...this.patientCalls.data, ...response];
    })
    .catch((error) => {
      this.patientCalls = {data: [], total: 0};
      this.errorMessage = error.status === 401 ? error.error.message : null;
      this.toastService.openErrorToast(error?.error?.message);
    });
  }

  prevPage(): void {
    if (this.index > 0) this.index--;
  }

  nextPage(): void {
    if (this.index + 1 < this.patientCalls.data.length) this.index++;
    this.nextPageChanged();
  }

  nextPageChanged(): void {
    if(this.index + 1 === (this.skip + this.limit)) {
      this.skip = this.index + 1;
      this.getPatientCalls();
    }
  }
}
